import { useState, useEffect } from "react";
import { Checkbox, message, Spin, Button } from "antd";
import { useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { CheckOutlined } from "@ant-design/icons";
import apiPath from "../../constants/apiPath";

function SubscriptionInner() {
  const navigate = useNavigate();
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [activePlan, setActivePlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState();
  const { request } = useRequest();

  useEffect(() => {
    getProfile()
    fetchSubscriptions();

  }, []);

  const getProfile = () => {
    request({
      url: apiPath.profile,
      method: "GET",
      onSuccess: (data) => {
        setProfile(data.data);
        // setActivePlan(profile?.subscriptionId)
        // setSelected(data.data);
      },
    });
  }

  const fetchSubscriptions = () => {
    setLoading(true);
    request({
      url: apiPath.common.subscription,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          const plans = data.data.data || [];
          setSubscriptionPlans(plans);

          // Set active plan if user has an active subscription
          // const userActivePlan = plans.find(plan => plan._id === profile?.subscriptionId);
          // if (userActivePlan) {
          //   setActivePlan(userActivePlan.name);
          // }
        } else {
          message.error(data.message || "Failed to fetch subscription plans");
        }
      },
      onError: (error) => {
        setLoading(false);
        message.error(error?.message || "An error occurred while fetching subscription plans");
      },
    });
  };

  const handlePlanSelect = (planName) => {
    setActivePlan(planName);

    request({
      url: apiPath.planPurchase,
      method: "POST",
      data: {
        planId: planName
      },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          setTimeout(() => navigate("/",), 200);
        } else {
          message.error(data.message || "Failed to fetch subscription plans");
        }
      },
      onError: (error) => {
        setLoading(false);
        message.error(error?.message || "An error occurred while fetching subscription plans");
      },
    });

    // setTimeout(() => {
    //   navigate(`/subscription-payment?plan=${planName}`);
    // }, 500);
  };

  // Format price for display
  const formatPrice = (price, currency) => {
    if (!price) return "";

    return `${price}${currency}`;
  };

  // Render plan features if available
  const renderPlanFeatures = (features) => {
    if (!features || !features.length) {
      return (
        <li>
          <div className="plan-list-check">
            <CheckOutlined />
          </div>
          <div className="plan-list-types">
            {/* <h6>Standard Features</h6> */}
            {/* <p>Basic subscription features included</p> */}
          </div>
        </li>
      );
    }

    return features.map((feature, index) => (
      <li key={index}>
        <div className="plan-list-check">
          <CheckOutlined />
        </div>
        <div className="plan-list-types">
          <h6>{feature.title}</h6>
          <p>{feature.description}</p>
        </div>
      </li>
    ));
  };

  return (
    <div className="profile-container">
      <h2 className="profile-title">Active Subscription</h2>

      {loading ? (
        <div className="loading-container">
          <Spin size="large" />
        </div>
      ) : (
        <div className="col-plan-cards pt-3">
          {subscriptionPlans.length > 0 ? (
            subscriptionPlans.map((plan, index) => (
              <div
                key={index}
                className={`plan-card ${profile?.subscriptionId === plan._id ? "active" : ""}`}
                onClick={() => handlePlanSelect(plan._id)}
              >
                <div className="plan-pricing-header">
                  {/* <h6>{plan.interval || "Monthly"}</h6> */}
                  <h4>{plan.name}</h4>
                  {profile?.subscriptionId === plan._id && (
                    <div className="plan-check">
                      <Checkbox checked />
                    </div>
                  )}
                </div>
                <div className="plan-pricing-rate">
                  <h6>{formatPrice(plan.currency, plan.price)}</h6>
                </div>
                <div className="plan-card-listmenu">
                  <ul>
                    <li>
                      <div className="plan-list-check">
                        <CheckOutlined />
                      </div>
                      <div className="plan-list-types">
                        {/* <h6>{plan.title}</h6> */}
                        <p>{plan.description}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            ))
          ) : (
            <div className="no-plans-message">
              <p>No subscription plans available at the moment. Please check back later.</p>
            </div>
          )}
        </div>
      )}
      {/* <div className="tab-modal-ft">
        <Button className="modal-footer-btn-1"
        >Cancel Membership</Button>
      </div> */}
    </div>
  );
}

export default SubscriptionInner;